import { render, staticRenderFns } from "./TicketTopicDataManagement.vue?vue&type=template&id=99859c2c&scoped=true&"
import script from "./TicketTopicDataManagement.vue?vue&type=script&lang=js&"
export * from "./TicketTopicDataManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99859c2c",
  null
  
)

export default component.exports